import React from "react";
import { ThemeProvider } from "@mui/styles";
import { createTheme, Theme, StyledEngineProvider } from "@mui/material/styles";
import AppRouter from "../pages/router";
import LogoBar from "../components/logoBar/LogoBar";
import "react-toastify/dist/ReactToastify.css"; // Stil dosyasını ekleyin
import { ToastContainer } from "react-toastify"; // ToastContainer ekleyin
import { SnackbarProvider } from "notistack";
import BookingErrorPopup from "../components/Popup/BookingErrorPopup/bookingErrorPopup";
// import { InteractionRequiredAuthError } from "@azure/msal-browser";
// import { useMsal } from "@azure/msal-react";

declare module "@mui/styles/defaultTheme" {
  interface DefaultTheme extends Theme {}
}

// Component definition
function App() {
  const theme = createTheme();

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <SnackbarProvider>
          <LogoBar />
          <ToastContainer position='bottom-right' />
          <AppRouter />
          <BookingErrorPopup isOpen={false} />
        </SnackbarProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

// Default export
export default App;
